import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  DrawingSessionService,
  SharedDrawingModule,
} from '@iqd/shared-drawing';
import {
  DrawingSessionService as BudgetDrawingSessionService,
  SharedQuotingModule,
} from '@iqd/shared-quoting';
import { SharedUtilsModule } from '@iqd/shared-utils';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { BudgetFormComponent } from './budget-form/budget-form.component';
import { BudgetResultComponent } from './budget-result/budget-result.component';
import { BudgetComponent } from './budget.component';
import { ContactDetailsModalComponent } from './contact-details-modal/contact-details-modal.component';
import { RequestAccessModalComponent } from './request-access-modal/request-access-modal.component';

@NgModule({
  imports: [
    SharedUtilsModule,
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    SharedQuotingModule,
    SharedDrawingModule,
  ],
  declarations: [
    BudgetComponent,
    BudgetFormComponent,
    BudgetResultComponent,
    RequestAccessModalComponent,
    ContactDetailsModalComponent,
  ],
  providers: [
    { provide: DrawingSessionService, useClass: BudgetDrawingSessionService },
  ],
})
export class BudgetModule {}
